<template>
  <div class="ls_spin_container">
    <h1 class="company_header mb-30" align="center">Сменить пароль</h1>

    <Form ref="formData" :model="formData" :rules="rules">
      <input type="text" style="display:none" />
      <input type="password" style="display:none" />


      <div>

        <!-- OLD PASSWORD -->
        <FormItem
          class="mb-40"
          prop="old_password"
        >
          <Input
            type="password"
            minlength="4"
            v-model="formData.old_password"
            placeholder="Текущий пароль"

          />
        </FormItem>

        <!-- NEW PASSWORD -->
        <FormItem
          prop="new_password"
        >
          <Input
            type="password"
            minlength="4"
            v-model="formData.new_password"
            placeholder="Новый пароль"

          />
        </FormItem>
      </div>

      <FormItem align="center">
        <Button
          type="success"
          @click="saveAction()"
          :disabled="!validForm"
        >Сохранить</Button
        >
        <!--<Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>-->
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="loading"></Spin>

  </div>
</template>

<script>
    import { base_url } from "../../http.js";

    export default {
        name: "currentUser",
        data() {
            return {
                // action: "edit",
                base_view_url: base_url + "/current_user/",
                metadata_url: base_url + "/current_user/",
                loading: false,
                // baseRules: {},
                // excludeFieldsRules: [],
                validForm: false,
                isChanged: false,

                formData: {
                    last_name: "",
                    first_name: "",
                    middle_name: "",
                    old_password: "",
                    new_password: "",
                },

                rules: {
                    old_password: [
                        {
                            required: true,
                            message: "Пожалуйста, заполните поле",
                            trigger: "change"
                        },
                        {
                            min: 6,
                            message: "Минимум 6 символа",
                            trigger: "change"
                        }
                    ],
                    new_password: [
                        {
                            required: true,
                            message: "Пожалуйста, заполните поле",
                            trigger: "change"
                        },
                        {
                            min: 6,
                            message: "Минимум 6 символа",
                            trigger: "change"
                        }
                    ]
                },

                // showEditPassword: false
            };
        },
        asyncComputed: {
            schema: {
                get() {
                    return this.$http.options(this.metadata_url).then(response => {
                        let schema = response.data.actions.PUT;
                        return schema;
                    });
                }
            }
        },
        watch: {
            "formData.old_password": function(to, from) {
                this.validateForm();
            },
            "formData.new_password": function(to, from) {
                this.validateForm();
            }
        },
        computed: {
            // showPassword() {
            //     return this.showEditPassword;
            // },

            disabledSaveButton() {
                return !this.validForm;
            }
        },
        methods: {
            fetchCurrentUser() {
                // this.loading = true;
                this.$http
                    .get(this.base_view_url)
                    .then(response => {
                        this.formData = response.data;

                        let data = response.data;
                        this.$store.commit("user_id", data.id);
                        this.$store.commit("user_full_name", data.full_name);
                        this.$store.commit("currency", data.currency);
                        this.$store.commit("permissions", data.permissions);
                        this.$store.commit("role", data.role);
                        this.$store.commit("role_display", data.role_display);
                        this.$store.commit("cashes", data.cashes);
                    })
                    .finally(() => {
                        this.isChanged = false;
                        this.loading = false;
                    });
            },

            validateForm() {
                this.$refs.formData.validate(valid => {
                    this.validForm = valid;
                });

                // this.$refs.formData.validate(valid => {
                //     if (this.formData.old_password === this.formData.new_password) {
                //         this.validForm = valid;
                //     } else {
                //         this.validForm = false;
                //     }
                // });
            },

            saveAction() {
                this.save();
                // if (this.validForm) {
                //     this.save();
                // } else {
                //     this.$Message.error("Некорректно заполнены поля!");
                // }
            },

            save() {
                this.loading = true;
                this.$http
                    .put(this.base_view_url, this.formData)
                    .then(response => {
                        this.$Message.success("Успешно сохранено");
                        this.isChanged = false;
                        this.fetchCurrentUser();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        created() {
            // this.loading = true;
        },
        mounted() {
            this.fetchCurrentUser();
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/user/modalPass.vue